import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import { Match, Event} from '../../models'
import template from './individual-duel-results.jade'
import sources from '../../../helpers/sources'
import '../status'
import '../match-times'
import '../lineups'
import getState from '../../services/create-event'
import notify from '@scoutgg/ftw/source/services/notification'
import emitter from '@scoutgg/ftw/source/services/emitter'

import '@scoutgg/ftw/source/atoms/form-control/form-control'

@Component('sporty')
@Template(template)
@Attribute('match', Match)
@Attribute('edit-mode', Boolean)
@Attribute('event-type', String)
export default class IndividualDuelResults extends HTMLElement {
  attached() {
    this.update(this.match.load()).then(() => {
      if(!this.events) this.events = []
    })
    this.state.listen(this, true)
  }

  get state() {
    return getState(this.match)
  }

  reset() {
    this.state.reset()
  }

  matchChange() {
    this.update(this.match.load())
    this.state.listen(this, true)
  }

  saveStats() {
    var lineups = this.match.lineups.map(lineup => {
      return {
        _id: lineup._id,
        match: lineup.matchId,
        player: lineup.playerId,
        team: lineup.teamId,
        stats: lineup.stats,
        status: lineup.status,
        duration: lineup.duration,
      }
    })

    this.match.post('lineups', {lineups})
      .then(() => {
        notify('Stats saved', {level: 'success', timeout: 3000})
        this.state.reload(true)
        emitter.emit('match-updated')
        this.editMode = false
      })
  }

  sendFeeds() {
    if(this.match.$isSubmitting) return
    this.match.post('send-feeds', {forceCalculations: true})
      .then(() => { notify('Events sent', {level: 'success', timeout: 5000}) })
      .catch((err) => {
        notify(err.message, {level: 'danger', timeout: 10000})
      })
      .then(() => this.render())
    this.render()
  }

  destroy(event) {
    if(this.isSubmittingRank) return
    this.isSubmittingRank = true
    event.$isSubmitting = true
    event.destroy().then(() => {
      this.state.reload()
      this.isSubmittingRank = false
      this.render()
    }).catch(() => {
      event.$isSubmitting = false
      this.isSubmittingRank = false
      this.render()
    })
    this.render()
  }

  canScrapeLineups(source) {
    var s = sources[source.source]
    return s && s.lineups
  }

  addWinner(lineup, type = 'slalom_duel_won') {
    if(this.isSubmittingRank) return
    this.isSubmittingRank = true
    lineup.$isSubmittingRank = true
    const participants = this.participants
    var event = {
      match: lineup.match._id,
      team: lineup.team._id,
      player: lineup.player._id,
      name: type,
      minute: lineup.stats.pair,
      second: 0,
    }
    this.match
      .post('events', {
         event: event,
         skipCalculations: true
       })
      .catch(err => console.error(err))
      .then(() => {
        this.state.reload(true)
        this.isSubmittingRank = false
        lineup.$isSubmitting = false
        this.render()
      })
    this.events.push(Event.create(event))
    this.render()
  }

  isDuelWinner(lineup) {
    const { stats } = lineup
    if(!stats) return

    const event = this.events.length && this.events.filter(
      z => z.player && (z.player._id === lineup.player._id)
    )
    const won = (event && event[0] && (event[0].name === 'slalom_duel_won'))
    return stats.winQ32 ||
      stats.winQ16 ||
      stats.winQ8 ||
      stats.winQ4 ||
      stats.winFinal ||
      stats.winBronzeFinal ||
      won
  }

  get participants() {
    if(!this.lineups) return {}
    return this.lineups.filter(z => z.status === 'confirmed')
  }

  get pairs() {
    if(!this.lineups) return
    const paired = {}
    const participants = this.participants.filter(l => l.stats && l.stats.pair)
    for(const l of participants) {
      const pair = l.stats.pair
      if(!paired[pair]) paired[pair] = []
      paired[pair].push(l.player)
    }
    const sets = Object.entries(paired)
      .sort(([a], [b]) => a - b)
      .map(([players]) => [players[0], players[1]])
    return sets

  }

  get duels() {
    if(!this.lineups) return
    const participants = this.participants
    const victories = (this.events || [])
      .filter(e => e.name === 'slalom_duel_won')
      .reduce((obj, e) => {
        obj[e.minute] = e
        return obj
      }, {})
    var prevPair
    var obj
    const pairObject = this.lineups
      .filter(l => l.position !== 'manager' && l.stats && l.stats.pair)
      .sort((a, b) => {
        const aPair = a.stats.pair
        const bPair = b.stats.pair
        return (
          aPair - bPair ||
          a.team.name.localeCompare(b.team.name)
        )
      })
      .reduce((pairs, l) => {
        if(!pairs[l.stats.pair]) {
          pairs[l.stats.pair] = [l]
        } else {
          pairs[l.stats.pair].push(l)
        }
        return pairs
      },{})
    return Object.values(pairObject)
  }
}
